import response from './mocks/modelCatalog.json';

// Mock the API boundary. Replace this function with the catalog request when ready.
export const getModelCatalog = async () => JSON.parse(JSON.stringify(response));
